'use client';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Link from 'next/link';
import NextImage from '@/features/Image';
import { sliceRoute } from '@/utils/sliceRoute';

const FeaturedCategoriesSlider = ({ data }: { data: any }) => {
  return (
    <div className="featured-categories__slider">
      <Swiper
        style={
          {
            '--swiper-wrapper-display': 'flex',
          } as React.CSSProperties
        }
        modules={[Navigation, Autoplay]}
        spaceBetween={10}
        slidesPerView={3.5}
        slidesOffsetBefore={10}
        slidesOffsetAfter={10}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        speed={500}
        loop={false}
        breakpoints={{
          576: {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            autoplay: {
              delay: 3000,
            },
          },
          768: {
            slidesPerView: 6,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            autoplay: {
              delay: 3000,
            },
          },
          992: {
            slidesPerView: 7,
            spaceBetween: 15,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            autoplay: {
              delay: 3000,
            },
          },
          1200: {
            slidesPerView: 8,
            spaceBetween: 25,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            autoplay: {
              delay: 3000,
            },
          },
        }}
        navigation={{
          nextEl: '.featured-categories__slider-next',
          prevEl: '.featured-categories__slider-prev',
        }}
        // onSlideChange={(swiper) => {
        //   const nextButton = document.querySelector(
        //     '.featured-categories__slider-next'
        //   );
        //   const prevButton = document.querySelector(
        //     '.featured-categories__slider-prev'
        //   );

        //   if (nextButton && prevButton) {
        //     if (swiper.isEnd) {
        //       nextButton.classList.remove('active');
        //     } else {
        //       nextButton.classList.add('active');
        //     }

        //     if (swiper.isBeginning) {
        //       prevButton.classList.remove('active');
        //     } else {
        //       prevButton.classList.add('active');
        //     }
        //   }
        // }}
      >
        {data.map((product: any, i: number) => {
          const url =
            product?.slug === 'hot-deals'
              ? '/hot-deals'
              : `${sliceRoute(product?.url)}`;
          return (
            <SwiperSlide key={i}>
              <Link href={`${url}`}>
                <div className="featured-categories-card">
                  <div className="card-image">
                    <NextImage
                      width={152}
                      height={152}
                      src={product.icon}
                      alt="Product.icon"
                    />
                  </div>
                  <div className="card-footer">
                    <p className="card-footer-text fs-small">{product.name}</p>
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default FeaturedCategoriesSlider;
